/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Typography, notification, Row, Spin, Empty, Modal, Space, Tag, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useFetchEditGuideline, useGetAnglePresets } from '../../hooks/useAnglePreset';
import AnglePresetDetails from './AnglePresetDetails';
import './editRenaming.scss';
import { UpOutlined, DownOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import EditModal from './EditModal';
import useLogout from '../../hooks/useLogout';

const EditRenamingModal = ({ companyId, companyName }) => {
    const [anglePresets, setAnglePresets] = useState([]);
    const [openAnglePresetGuidelines, setOpenAnglePresetGuidelines] = useState(false);
    const [anglePresetId, setAnglePresetId] = useState('');
    const [api, contextHolder] = notification.useNotification();
    const [editPresetId, setEditPresetId] = useState({});
    const [presetData, setPresetData] = useState([]);
    const { logout } = useLogout();

    const onSuccess = data => {
        setAnglePresets(data);
    };
    const { isFetching } = useGetAnglePresets(onSuccess, companyId);
    const openAnglePreset = AP_id => {
        setAnglePresetId(AP_id);
    };
    const { mutate: getEditDetails, isLoading: fetchingDetails } = useFetchEditGuideline(onSuccessFetch, onErrorFetch);
    function onSuccessFetch(res) {
        setPresetData(res?.data?.data);
    }
    function onErrorFetch(err) {
        console.log(err);
        if (err?.response?.status === 401) logout();
    }
    const handleCloseAnglePresetSection = () => {
        api['success']({
            message: ' Filename Pattern updated successfully!!!',
        });
        setAnglePresetId('');
    };
    const handleGetGuidelines = id => {
        setOpenAnglePresetGuidelines(true);
        setEditPresetId(id);
        getEditDetails(id._id);
        // refetch();
    };
    return (
        <div>
            {contextHolder}
            <Typography.Title level={4}>
                Viewing Angle preset for client : <b>{companyName}</b>
            </Typography.Title>

            {isFetching ? (
                <Row className="alignContentcenter">
                    <Spin tip="Loading..." />
                </Row>
            ) : (
                anglePresets.length == 0 && (
                    <div className="alignContentcenter">
                        {' '}
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </div>
                )
            )}
            {anglePresets.map(AP => (
                <div className="anglePresetRow" key={AP._id}>
                    <div
                        className="anglePresetHeader"
                        onClick={() => {
                            anglePresetId === AP._id ? setAnglePresetId('') : openAnglePreset(AP._id);
                        }}
                    >
                        <Space>
                            <Typography.Title level={5} style={{ margin: 0 }}>
                                {AP.name}
                            </Typography.Title>
                            {<Tag color={AP.isActive ? '#87d068' : '#ff0000'}>{AP.isActive ? 'ACTIVE' : 'Hidden'}</Tag>}

                            {!AP?.isCompleted ? (
                                <Tooltip title="Output Filename Pattern does not exist for all Angles">
                                    <ExclamationCircleFilled className="colorRed" />
                                </Tooltip>
                            ) : null}
                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                Created {AP.createdAt ? new Date(AP.createdAt).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                                {` by ${AP.createdBy?.name || '—'}`}
                            </Typography.Text>
                        </Space>
                        <div className="anglePresetHeaderBtn">
                            <Button
                                style={{ marginRight: '10px' }}
                                onClick={e => {
                                    console.log('Manage guideline clicked');
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleGetGuidelines(AP);
                                }}
                            >
                                Manage Guidelines
                            </Button>
                            {anglePresetId === AP._id ? (
                                <UpOutlined className="alignContentcenter" />
                            ) : (
                                <DownOutlined className="alignContentcenter" />
                            )}
                        </div>
                    </div>
                    {anglePresetId === AP._id && (
                        <AnglePresetDetails companyId={companyId} anglePresetId={anglePresetId} unsetAnglePresetId={handleCloseAnglePresetSection} />
                    )}
                </div>
            ))}
            {!!openAnglePresetGuidelines && (
                <EditModal
                    openAnglePresetGuidelines={openAnglePresetGuidelines}
                    setOpenAnglePresetGuidelines={setOpenAnglePresetGuidelines}
                    editPresetId={editPresetId?._id}
                    presetName={editPresetId?.name}
                    presetData={presetData}
                    setPresetData={setPresetData}
                    getEditDetails={getEditDetails}
                    fetchingDetails={fetchingDetails}
                />
            )}
        </div>
    );
};

export default EditRenamingModal;
